module.exports = __webpack_public_path__ + "KaTeX_Math-Italic.aab87d9d.woff";